'use strict';
// #region menu
var menuBtn = document.querySelectorAll('.button-menu');
var sideMenu = document.querySelector('.page__menu');
var menuLinks = document.querySelectorAll('.page__menu .nav__link');
var body = document.querySelector('.page__body');
function toggleMenu(forceState) {
    var isActive = forceState !== undefined ? forceState : !sideMenu.classList.contains('page__menu--is-open');
    sideMenu.classList.toggle('page__menu--is-open', isActive);
    body.classList.toggle('page__body--no-scroll', isActive);
    body.classList.toggle('page__body--is-under-menu', isActive);
    menuBtn.forEach(function(btn) {
        btn.classList.toggle('button-menu--is-active', isActive);
    });
}
menuBtn.forEach(function(btn) {
    btn.addEventListener('click', function() {
        return toggleMenu();
    });
});
menuLinks.forEach(function(link) {
    link.addEventListener('click', function() {
        return toggleMenu(false);
    });
});
// #endregion
// #region slider
function initSlider() {
    var track = document.getElementById('slider-track');
    var slides = Array.from(track.querySelectorAll('.slider__slide'));
    var dotsContainer = document.getElementById('slider-dots');
    var slidesPerPage = calcSlidesPerPage();
    var pageCount = Math.ceil(slides.length / slidesPerPage);
    function calcSlidesPerPage() {
        if (window.matchMedia('(min-width: 1280px)').matches) return slides.length;
        return window.matchMedia('(min-width: 768px)').matches ? 2 : 1;
    }
    function renderDots() {
        var _loop = function(i) {
            var btn = document.createElement('button');
            btn.className = 'slider__dots-button';
            btn.type = 'button';
            btn.setAttribute('aria-label', "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443 ".concat(i + 1));
            btn.dataset.index = String(i);
            if (i === 0) btn.classList.add('slider__dots-button--active');
            btn.addEventListener('click', function() {
                var left = i * track.clientWidth;
                track.scrollTo({
                    left: left,
                    behavior: 'smooth'
                });
                updateActiveDot();
            });
            dotsContainer.appendChild(btn);
        };
        slidesPerPage = calcSlidesPerPage();
        pageCount = Math.ceil(slides.length / slidesPerPage);
        if (window.matchMedia('(min-width: 1024px)').matches) {
            dotsContainer.style.display = 'none';
            return;
        } else dotsContainer.style.display = '';
        dotsContainer.innerHTML = '';
        for(var i = 0; i < pageCount; i++)_loop(i);
    }
    function updateActiveDot() {
        var pageIndex = Math.round(track.scrollLeft / (track.clientWidth / slidesPerPage));
        if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 2) pageIndex = pageCount - 1;
        var dots = dotsContainer.querySelectorAll('.slider__dots-button');
        dots.forEach(function(d, i) {
            d.classList.toggle('slider__dots-button--active', i === pageIndex);
        });
    }
    var rafPending = false;
    function onScroll() {
        if (!rafPending) {
            rafPending = true;
            window.requestAnimationFrame(function() {
                updateActiveDot();
                rafPending = false;
            });
        }
    }
    track.addEventListener('scroll', onScroll, {
        passive: true
    });
    var resizeTimer;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            var oldSlidesPerPage = slidesPerPage;
            var newSlidesPerPage = calcSlidesPerPage();
            if (newSlidesPerPage !== oldSlidesPerPage) {
                renderDots();
                track.scrollTo({
                    left: 0
                });
            }
        }, 150);
    });
    renderDots();
    setTimeout(updateActiveDot, 0);
    // open img
    var lightbox = document.getElementById('slider-lightbox');
    var lightboxImg = document.getElementById('slider-lightbox-img');
    var lightboxClose = document.querySelector('.slider-lightbox__button');
    slides.forEach(function(slide) {
        slide.addEventListener('click', function() {
            var img = slide.querySelector('img');
            if (!img) return;
            lightboxImg.src = img.src;
            lightbox.classList.add('slider-lightbox--active');
        });
    });
    function closeLightbox() {
        lightbox.classList.remove('slider-lightbox--active');
        lightboxImg.src = '';
    }
    lightboxClose.addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', function(e) {
        if (e.target === lightbox) closeLightbox();
    });
}
document.addEventListener('DOMContentLoaded', initSlider); // #endregion

//# sourceMappingURL=Museum.bf3cbe56.js.map
